module.exports = ".test-card {\n    cursor: move;\n}\n\n.heats {\n    font-size: 14px;\n    display: block;\n}\n\n.time {\n    font-size: 24px;\n    text-align: right;\n}\n\n.drag-border {\n    display: none;\n}\n\n.heats .badge {\n    padding: 2px;\n    border-radius: 2px;\n}\n\n.capitalize {\n    text-transform: uppercase;\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/test-card/test-card.component.css
// module id = ./src/app/test-card/test-card.component.css
// module chunks = main